<template>
    <div class="PIDContainer" v-if="result.propertyResult.id && result.pidResult.name">
        <div class="property-selector">
            <el-select
                v-model="property_private"
                value-key="name"
                :placeholder="$t('property.selectProperty')"
                @change="initialData"
            >
                <el-option
                    v-for="(item, index) in portfolioResp.properties"
                    :key="index"
                    :label="item.name"
                    :value="item"
                >
                    <img class="property-flag" :src="item.country_flag_url" alt />
                    <span class="property-name">{{ item.name }}</span>
                </el-option>
            </el-select>

            <el-button
                type="primary"
                @click="goToManage"
                class="hidden-sm-and-down"
            >{{$t('property.ManageYourProperty')}}</el-button>
        </div>

        <section class="property-content">
            <div class="property-content-l">
                <div class="property-profile property-card">
                    <div class="property-profile-img" v-if="result.propertyResult.picture">
                        <img :src="result.propertyResult.picture" alt="Property Image" />
                    </div>
                    <div
                        class="property-type"
                    >{{ GetPropertyType(result.propertyResult.propertyType) }}</div>
                    <div class="property-name">{{result.propertyResult.name}}</div>
                    <div
                        class="property-desc"
                    >{{result.propertyResult.apartmentNumber}} {{result.propertyResult.address}}, {{result.propertyResult.city}}, {{result.propertyResult.country_name}}, {{result.propertyResult.postalCode}}</div>
                    <ul class="property-layout">
                        <li
                            class="layout-internal"
                        >{{$t('property.InternalArea')}} {{result.propertyResult.areaInternal | NumFormatToZero | KeepODecimal }} {{ UnitFormat(result.propertyResult.areaUnit) }}</li>
                        <li
                            v-if="result.propertyResult.propertyType == 3"
                            class="layout-floor"
                        >{{result.propertyResult.floor | NumFormat }} / {{result.propertyResult.totalFloorsBuilding | NumFormat }} {{$t('property.floor')}}</li>
                        <li
                            class="layout-areaLot"
                            v-else
                        >{{$t('property.LotSize')}} {{result.propertyResult.areaLot | NumFormatToZero | KeepODecimal}} {{ UnitFormat(result.propertyResult.areaUnit) }}</li>
                        <li
                            class="layout-bedrooms"
                        >{{result.propertyResult.bedrooms | NumFormatToZero}} {{$t('property.beds')}}</li>
                        <li
                            class="layout-bathrooms"
                        >{{result.propertyResult.bathrooms | NumFormatToZero}} {{$t('property.bathrooms')}}</li>
                        <li
                            class="layout-kitchens"
                        >{{result.propertyResult.kitchens | NumFormatToZero}} {{$t('property.kitchen')}}</li>
                        <li
                            class="layout-livingRooms"
                        >{{result.propertyResult.livingRooms | NumFormatToZero}} {{$t('property.living')}}</li>
                        <li
                            class="layout-parkingSpaces"
                        >{{result.propertyResult.parkingSpaces | NumFormatToZero}} {{$t('property.parking')}}</li>
                    </ul>
                    <div class="border-top flex-item">
                        <p class="item-name">{{$t('property.PurchaseDate')}}</p>
                        <p class="item-val">{{result.propertyResult.purchaseDate | returnDash}}</p>
                    </div>
                    <div class="border-top flex-item">
                        <p class="item-name">{{$t('property.Completion')}}</p>
                        <p class="item-val">{{result.propertyResult.completionDate | returnDash}}</p>
                    </div>
                    <div class="border-top flex-item">
                        <p class="item-name">{{$t('property.Ownership')}}</p>
                        <p
                            class="item-val"
                        >{{result.propertyResult.ownershipType_name | returnDash}}</p>
                    </div>
                    <div class="border-top editor-item text-right">
                        <a class="edit-link" @click="editProp('layout')">{{$t('property.Edit')}}</a>
                    </div>
                </div>
                <div class="property-mortgage property-card">
                    <a class="edit-btn" @click="editProp('mortgage')">{{$t('property.Edit')}}</a>
                    <span
                        class="mortgage-title"
                    >{{$t('property.MORTGAGE')}} ({{result.pidResult.currency}})</span>
                    <div v-if="result.pidResult.has_mortgage == 2" class="progress-dashboard">
                        <p class="mortgage-hint">{{$t('property.noMortgage')}}</p>
                    </div>
                    <div v-else-if="result.pidResult.has_mortgage == 1">
                        <span
                            class="mortgage-subtitle"
                        >{{$t('property.StartFrom')}} {{$t('property.mortgages_startDate', {year: result.propertyResult.mortgages_startDate.split('-')[0], month: result.propertyResult.mortgages_startDate.split('-')[1]})}}</span>
                        <div class="progress-dashboard">
                            <el-progress
                                type="dashboard"
                                :percentage="result.pidResult.mortgage_percent"
                                :color="'#9fdbfc'"
                            ></el-progress>
                            <div class="mortgage-paid">{{ $t('property.MortgagePaid') }}</div>
                        </div>
                        <ul class="mortgage-list">
                            <li class="mortgage-flex">
                                <p class="flex-item">{{$t('property.MonPayment')}}</p>
                                <p
                                    class="flex-val"
                                >{{result.pidResult.currency}} {{result.pidResult.mortgage.monthly_payment | NumFormat}}</p>
                            </li>
                            <li class="mortgage-flex">
                                <p class="flex-item">{{$t('property.TotalMortgage')}}</p>
                                <p
                                    class="flex-val"
                                >{{result.pidResult.currency}} {{result.pidResult.mortgage.total_mortgage | NumFormat}}</p>
                            </li>
                            <li class="mortgage-flex">
                                <p class="flex-item">{{$t('property.InterestRate')}}</p>
                                <p
                                    class="flex-val"
                                >{{result.pidResult.mortgage.interest_rate | NumFormat}}%</p>
                            </li>
                            <li class="mortgage-flex">
                                <p class="flex-item">{{$t('property.Length')}}</p>
                                <p
                                    class="flex-val"
                                >{{result.pidResult.mortgage.length | returnDash}} {{$t('property.Years')}}</p>
                            </li>
                        </ul>
                    </div>
                    <div v-else-if="result.pidResult.has_mortgage == 0" class="progress-dashboard">
                        <p class="mortgage-hint">{{$t('property.noMortgageNull')}}</p>
                    </div>
                </div>
                <div class="property-expenses property-card">
                    <a class="edit-btn" @click="editProp('expense')">{{$t('property.Edit')}}</a>
                    <span
                        class="expenses-title"
                    >{{$t('property.PropertyExpenses')}} ({{result.pidResult.currency}})</span>
                    <span class="expenses-subtitle">({{$t('property.Monthly')}})</span>
                    <div id="expense-pie"></div>
                    <ul class="expenses-list">
                        <li>{{$t('property.PropertyManagement')}}</li>
                        <li class="management">{{$t('property.RentalManagement')}}</li>
                        <li class="tax">{{$t('property.Tax')}}</li>
                        <li class="insurance">{{$t('property.Insurance')}}</li>
                    </ul>
                </div>
            </div>
            <div class="property-content-r">
                <div class="common-flex flex-reserve">
                    <div class="current-value common-style">
                        <h2>{{$t('property.CURRENTVALUE')}}</h2>
                        <div class="earnings-profile box-bottom">
                            <div class="price-list">
                                <p
                                    class="current-val"
                                    v-if="result.investment_overview.current_value_estimate"
                                >{{result.pidResult.currency_symbol}} {{result.investment_overview.current_value_estimate[0].total | NumFormat}} {{result.pidResult.currency}}</p>
                                <p class="current-val" v-else>-</p>

                                <p
                                    class="subval"
                                    v-if="result.investment_overview.current_value_estimate"
                                >{{browser_currency_symbol}} {{result.investment_overview.current_value_estimate[1].total | NumFormat}} {{result.investment_overview.current_value_estimate[1].currency}}</p>

                                <p class="purchase-price">{{$t('property.PurchasePrice')}}</p>
                                <p
                                    class="purchase-price-num"
                                    v-if="result.investment_overview.purchase_price"
                                >{{result.pidResult.currency_symbol}} {{result.investment_overview.purchase_price[0].total | NumFormat}} {{result.pidResult.currency}}</p>
                                <p class="purchase-price-num" v-else>-</p>

                                <p
                                    class="subval"
                                    v-if="result.investment_overview.purchase_price"
                                >{{browser_currency_symbol}} {{result.investment_overview.purchase_price[1].total | NumFormat}} {{result.investment_overview.purchase_price[1].currency}}</p>
                                <p class="subval" v-else>-</p>
                            </div>
                            <div class="current-gain" v-if="result.pidResult.appreciation">
                                <div class="border-right">
                                    <p class="gain-title">{{$t('property.MonthlyGain')}}</p>
                                    <p
                                        class="gain-percent"
                                        :class="{'up': result.pidResult.appreciation.percentage_monthly_gain > 0, 'down': result.pidResult.appreciation.percentage_monthly_gain < 0}"
                                    >{{result.pidResult.appreciation.percentage_monthly_gain}}%</p>
                                    <p
                                        class="gain-num"
                                    >{{result.pidResult.appreciation.total_monthly_gain | NumFormatAndShowSymbol}} {{result.pidResult.currency_symbol}}{{result.pidResult.appreciation.total_monthly_gain | NumFormat}}</p>
                                </div>
                                <div>
                                    <p class="gain-title">{{$t('property.TotalGain')}}</p>
                                    <p
                                        class="gain-percent"
                                        :class="{'up': result.pidResult.appreciation.percentage_total_gain > 0, 'down': result.pidResult.appreciation.percentage_total_gain < 0}"
                                    >{{result.pidResult.appreciation.percentage_total_gain}}%</p>
                                    <p
                                        class="gain-num"
                                    >{{result.pidResult.appreciation.total_gain | NumFormatAndShowSymbol}} {{result.pidResult.currency_symbol}}{{result.pidResult.appreciation.total_gain | NumFormat}}</p>
                                </div>
                            </div>
                            <div class="current-gain" v-else>
                                <div class="border-right">
                                    <p class="gain-title">{{$t('property.MonthlyGain')}}</p>
                                    <p class="gain-percent">-%</p>
                                    <p class="gain-num">-</p>
                                </div>
                                <div>
                                    <p class="gain-title">{{$t('property.TotalGain')}}</p>
                                    <p class="gain-percent">-%</p>
                                    <p class="gain-num">-</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="line-overlay">
                        <div id="line-chart" class="line-chart"></div>
                        <span
                            class="no-valuation"
                            v-if="!result.pidResult.valuations_graph_display"
                        >{{$t("property.NoValuation")}}</span>
                    </div>
                </div>
                <div class="common-flex common-group">
                    <div class="cash-flow common-style">
                        <h2 v-html="$t('property.CASHFLOW')"></h2>
                        <div class="cash-box box-bottom">
                            <div class="cash-item">
                                <p>{{$t('property.NetCashFlow')}}</p>
                                <p
                                    class="net-num"
                                    :class="{red: result.pidResult.net_cash_flow.net_cash_flow < 0 }"
                                >{{result.pidResult.net_cash_flow.net_cash_flow | NumFormatAndShowSymbol}}{{result.pidResult.currency_symbol}}{{result.pidResult.net_cash_flow.net_cash_flow | NumFormat}}</p>
                                <div class="cash-card">
                                    <img
                                        src="../../../../website_20/static/img/icon-pid-up.svg"
                                        alt="Up Icon"
                                    />
                                    <p class="cash-title">{{$t('property.CurrentRent')}}</p>
                                    <p
                                        class="cash-num"
                                    >{{result.pidResult.net_cash_flow.current_rental_income | NumFormatAndShowSymbol}}{{result.pidResult.currency_symbol}}{{result.pidResult.net_cash_flow.current_rental_income | NumFormat}}</p>
                                </div>
                            </div>
                            <div class="cash-item">
                                <p>{{$t('property.NetYield')}}</p>
                                <p
                                    class="net-num"
                                    :class="{red: result.pidResult.net_cash_flow.net_percentage < 0 }"
                                >{{result.pidResult.net_cash_flow.net_percentage | NumFormat }}%</p>
                                <div class="cash-card">
                                    <img
                                        src="../../../../website_20/static/img/icon-pid-down.svg"
                                        alt="Down Icon"
                                    />
                                    <p class="cash-title">{{$t('property.MortgageExpenses')}}</p>
                                    <p
                                        class="cash-num"
                                    >{{result.pidResult.net_cash_flow.outgoing | NumFormatAndShowSymbol}}{{result.pidResult.currency_symbol}}{{result.pidResult.net_cash_flow.outgoing | NumFormat}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="property-outlook common-style box-bottom">
                        <div class="outlook-title">
                            <h2>{{$t('property.PROPERTYOUTLOOK')}}</h2>
                        </div>
                        <ul class="outlook-slider">
                            <li
                                class="strong-sell"
                                :class="{'pin': result.pidResult.action_recommendation_id == 4}"
                            >
                                <span
                                    class="outlook-advice"
                                    v-if="result.pidResult.action_recommendation_id == 4"
                                >{{$t('property.outlookHint4')}}</span>
                            </li>
                            <li
                                class="sell"
                                :class="{'pin': result.pidResult.action_recommendation_id == 3}"
                            >
                                <span
                                    class="outlook-advice"
                                    v-if="result.pidResult.action_recommendation_id == 3"
                                >{{$t('property.outlookHint3')}}</span>
                            </li>
                            <li
                                class="hold"
                                :class="{'pin': result.pidResult.action_recommendation_id == 2}"
                            >
                                <span
                                    class="outlook-advice"
                                    v-if="result.pidResult.action_recommendation_id == 2"
                                >{{$t('property.outlookHint2')}}</span>
                            </li>
                            <li
                                class="strong-hold"
                                :class="{'pin': result.pidResult.action_recommendation_id == 1}"
                            >
                                <span
                                    class="outlook-advice"
                                    v-if="result.pidResult.action_recommendation_id == 1"
                                >{{$t('property.outlookHint1')}}</span>
                            </li>
                        </ul>
                        <div
                            class="outlook-msg-box"
                            :class="{'red': result.pidResult.action_recommendation_id == 4 || result.pidResult.action_recommendation_id == 3}"
                        >
                            <p
                                v-if="result.pidResult.action_recommendation_id"
                            >{{$t('property.outlookSuggestion'+ result.pidResult.action_recommendation_id )}}</p>
                            <p v-else>{{$t('property.outlookSuggestion_no_recommend')}}</p>
                        </div>
                    </div>
                </div>
                <div class="rent-analysis common-style">
                    <h2>
                        {{$t('property.RentAnalysis')}}
                        <span>({{result.pidResult.currency}})</span>
                    </h2>
                    <div class="rent-list">
                        <div class="rent-card">
                            <h3>
                                {{$t('property.CurrentRent')}}
                                <a
                                    class="edit-icon"
                                    @click="editProp('rent')"
                                ></a>
                            </h3>
                            <div class="rent-flex">
                                <!-- 1 means has rent -->
                                <div class="rent-item" v-if="result.pidResult.is_rented == 1">
                                    <p class="rent-revenue">{{$t('property.MonthlyRevenue')}}</p>
                                    <p
                                        class="rent-num"
                                    >{{result.pidResult.currency_symbol}}{{result.pidResult.net_cash_flow.rent | NumFormat}}</p>
                                </div>
                                <!-- 1 means has rent -->
                                <div class="rent-item" v-if="result.pidResult.is_rented == 1">
                                    <p class="rent-revenue">{{$t('property.GrossYield')}}</p>
                                    <p
                                        class="rent-percent"
                                    >{{result.pidResult.net_cash_flow.gross_percentage | KeepOneDecimal}}%</p>
                                </div>
                                <!-- 2 means no rent -->
                                <div class="rent-item" v-if="result.pidResult.is_rented == 2">
                                    <p class="no-rent">{{$t('property.NoRentalData')}}</p>
                                </div>
                                <!-- 0 means has no rent -->
                                <div class="rent-item" v-if="result.pidResult.is_rented == 0">
                                    <p class="no-rent">{{$t('property.NotExistRentalData')}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="rent-card">
                            <h3>{{$t('property.AirbnbRentalForecast')}}</h3>
                            <div class="rent-flex">
                                <div class="rent-item">
                                    <p class="rent-revenue">{{$t('property.MonthlyRevenue')}}</p>
                                    <p
                                        class="rent-num"
                                        v-if="result.pidResult.rental.airbnb_monthly "
                                    >{{result.pidResult.currency_symbol}}{{result.pidResult.rental.airbnb_monthly | NumFormat}}</p>
                                    <p
                                        class="rent-calculate"
                                        v-if="!result.pidResult.rental.airbnb_monthly"
                                    >{{$t('property.CurrentlyCalculating')}}</p>
                                </div>

                                <div class="rent-item" v-if="result.pidResult.rental.airbnb_daily">
                                    <p class="rent-revenue">{{$t('property.DailyRate')}}</p>
                                    <p
                                        class="rent-percent"
                                    >{{result.pidResult.currency_symbol}}{{result.pidResult.rental.airbnb_daily | NumFormat}}</p>
                                </div>
                            </div>
                            <div
                                class="rent-occupancy"
                                v-if="result.pidResult.rental.airbnb_occupancy"
                            >
                                <div class="occupancy-flex">
                                    <span class="occupancy-label">{{$t('property.Occupancy')}}</span>
                                    <span
                                        class="occupancy-val"
                                    >{{result.pidResult.rental.airbnb_occupancy}}%</span>
                                </div>

                                <div
                                    class="occupancy-percent"
                                    v-if="result.pidResult.rental.airbnb_occupancy"
                                >
                                    <el-progress
                                        :percentage="result.pidResult.rental.airbnb_occupancy > 100 ? 100 : result.pidResult.rental.airbnb_occupancy"
                                        :show-text="false"
                                        :color="'#7076c8'"
                                    ></el-progress>
                                </div>
                            </div>
                        </div>
                        <div class="rent-card">
                            <h3>{{$t('property.StandardMonthlyRentalEstimate')}}</h3>
                            <div class="rent-flex">
                                <div class="rent-item">
                                    <p class="rent-revenue">{{$t('property.MonthlyRevenue')}}</p>
                                    <p
                                        class="rent-num"
                                        v-if="result.pidResult.rental.std_monthly"
                                    >{{result.pidResult.currency_symbol}}{{result.pidResult.rental.std_monthly | NumFormat}}</p>
                                    <p
                                        class="rent-calculate"
                                        v-if="!result.pidResult.rental.std_monthly"
                                    >{{$t('property.CurrentlyCalculating')}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="revenue-comparison"
                        v-show="result.pidResult.rental.comparison_display"
                    >
                        <div class="comparison-flex">
                            <div id="comparison-chart"></div>
                            <div class="comparison-result">
                                <p
                                    v-if="result.pidResult.rental.std_monthly - result.pidResult.rental.airbnb_monthly > 0"
                                >
                                    {{$t('property.StdMonthlyHint1')}} {{result.pidResult.currency_symbol}}{{result.pidResult.rental.std_monthly - result.pidResult.rental.airbnb_monthly | NumFormat}}
                                    {{$t('property.StdMonthlyHint2')}}
                                </p>
                                <p
                                    v-else-if="result.pidResult.rental.airbnb_monthly - result.pidResult.rental.std_monthly > 0"
                                >
                                    {{$t('property.AirbnbRentalHint1')}} {{result.pidResult.currency_symbol}}{{result.pidResult.rental.airbnb_monthly - result.pidResult.rental.std_monthly | NumFormat}}
                                    {{$t('property.AirbnbRentalHint2')}}
                                </p>
                            </div>
                        </div>
                        <ul class="comparison-dot-list">
                            <li>{{$t('property.CurrentRent')}}</li>
                            <li>{{$t("property.AirbnbRental1")}}</li>
                            <li>{{$t("property.StandardMonthlyRental")}}</li>
                        </ul>
                    </div>

                    <div class="book-consultation">
                        <a
                            class="btn solid-btn"
                            href="https://hs.propertypassbook.com/meetings/passbookpremier/30-minute-global-portfolio-strategy-discussion"
                        >{{$t('property.BookaConsultation')}}</a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
let defaultImg = require("../../../../website_20/static/img/default-no-img.svg");
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/line");
require("echarts/lib/chart/pie");
require("echarts/lib/chart/bar");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/legend");
require("echarts/lib/component/title");

let lineChart, expensePie, comparisonChart, loading;

export default {
    name: "PIDContainer",
    props: [
        "requestHeaders",
        "requestParams",
        "propertySelector",
        "portfolioResp",
        "browser_currency_symbol"
    ],
    data() {
        const $t = this.$t.bind(this);
        return {
            result: {
                propertyResult: {},
                pidResult: {},
                investment_overview: {}
            },
            property_private: {}
        };
    },

    beforeMount() {
        this.loading();
        this.initialData();
    },

    activated() {
        this.initialData();
    },

    updated() {
        this.$nextTick(function() {
            this.initialChart();
        });
    },

    methods: {
        loading() {
            loading = this.$loading({
                lock: true,
                target: ".main-container",
                text: this.$t("searchResultPage.loading"),
                color: "#3b6bbf",
                background: "rgba(255, 255, 255, 0.8)"
            });
        },

        initialData() {
            let propertyId =
                this.property_private.id || this.propertySelector.id;

            if (!propertyId || propertyId == 0) return;
            let url = `${this.requestParams.ppbApi}api/property/${propertyId}`;
            let urlPID = `${this.requestParams.ppbApi}api/pid/${propertyId}`;

            this.$http.get(urlPID, this.requestHeaders).then(resp => {
                if (resp.status == 200) {
                    this.result.investment_overview = JSON.parse(
                        JSON.stringify(resp.data.investment_overview)
                    );
                    if (
                        !this.result.investment_overview.current_value_estimate
                    ) {
                        this.result.investment_overview.current_value_estimate = 0;
                    }
                    if (!this.result.investment_overview.purchase_price) {
                        this.result.investment_overview.purchase_price = 0;
                    }
                    if (!this.result.investment_overview.accumulated_equity) {
                        this.result.investment_overview.accumulated_equity = 0;
                    }
                    if (!this.result.investment_overview.capital_appreciation) {
                        this.result.investment_overview.capital_appreciation = 0;
                    }

                    let pidResult = resp.data;

                    if (pidResult.mortgage_percent == null) {
                        pidResult.mortgage_percent = 0;
                    }
                    if (!pidResult.rental || pidResult.rental == "") {
                        pidResult.rental = {
                            airbnb_monthly: undefined,
                            airbnb_daily: undefined,
                            airbnb_occupancy: undefined,
                            std_monthly: undefined
                        };
                    }

                    if (!pidResult.mortgage || pidResult.mortgage == "") {
                        pidResult.mortgage = {
                            monthly_payment: 0,
                            total_mortgage: 0,
                            interest_rate: 0,
                            length: 0
                        };
                    }

                    for (const attr in pidResult) {
                        if (
                            pidResult.hasOwnProperty(attr) &&
                            typeof pidResult[attr] == "object"
                        ) {
                            let keys = pidResult[attr];
                            for (const key in keys) {
                                if (keys.hasOwnProperty(key)) {
                                    let element = keys[key];
                                    if (Array.isArray(element)) {
                                        keys[key] = keys[key][0].total;
                                    } else if (element == null) {
                                        keys[key] = 0;
                                    }
                                }
                            }
                        }
                    }

                    this.result.pidResult = pidResult;
                }
                this.$emit("loaded", true);
                loading.close();
            });

            this.$http.get(url, this.requestHeaders).then(resp => {
                if (resp.status == 200) {
                    this.result.propertyResult = resp.data;
                    this.property_private = resp.data;
                    if (!this.result.propertyResult.mortgages_startDate) {
                        this.result.propertyResult.mortgages_startDate = "-";
                    }
                }
            });
        },

        initialChart() {
            let field = this.result.pidResult;

            function NumFormat(val) {
                if (!val) return "-";
                val = Number.parseInt(val);
                val = Math.abs(val);
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }

            lineChart = echarts.init(document.getElementById("line-chart"));
            let lineOptions;

            if (field.valuations_graph_display) {
                lineOptions = {};
                lineOptions = {
                    title: {
                        text: this.$t("property.PROPERTYVALUATION"),
                        top: 10,
                        left: 26,
                        textStyle: {
                            color: "#333",
                            fontFamily: "GothamMedium",
                            fontSize: 12
                        }
                    },
                    legend: {
                        show: true,
                        selectedMode: false,
                        top: 30,
                        left: 26,
                        padding: [0, 0, 27, 0],
                        align: "left",
                        data: [
                            this.$t("property.PropertyValuation"),
                            this.$t("property.PurchasePrice")
                        ]
                    },
                    tooltip: {
                        trigger: "axis",
                        opacity: "0.9",
                        backgroundColor: "#485465",
                        textStyle: {
                            fontFamily: "GothamBook",
                            fontSize: "8.4",
                            color: "#fff"
                        }
                    },
                    grid: {
                        left: "26",
                        right: "10",
                        bottom: "45",
                        containLabel: false
                    },
                    xAxis: [
                        {
                            axisLabel: {
                                fontFamily: "GothamBook",
                                fontSize: "10",
                                color: "#666"
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#f5f7f8"
                                }
                            },
                            type: "category",
                            boundaryGap: false,
                            data: []
                        }
                    ],
                    yAxis: [
                        {
                            show: false,
                            axisLabel: {
                                fontFamily: "GothamBook",
                                fontSize: "10",
                                color: "#666"
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#f5f7f8"
                                }
                            },
                            splitLine: {
                                lineStyle: {
                                    color: ["#f5f7f8"]
                                }
                            }
                        }
                    ],
                    series: [
                        {
                            name: this.$t("property.PropertyValuation"),
                            type: "line",
                            itemStyle: {
                                normal: {
                                    color: {
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        type: "linear",
                                        global: false,
                                        colorStops: [
                                            {
                                                offset: 0,
                                                color:
                                                    "rgba(67, 146, 241, 0.35)"
                                            },
                                            {
                                                offset: 1,
                                                color:
                                                    "rgba(67, 146, 241, 0.05)"
                                            }
                                        ]
                                    },
                                    lineStyle: {
                                        width: 3,
                                        type: "solid",
                                        color: "#0180ff"
                                    }
                                }
                            },
                            areaStyle: {
                                normal: {}
                            },
                            data: []
                        },
                        {
                            name: this.$t("property.PurchasePrice"),
                            type: "line",
                            lineStyle: {
                                color: "#203862",
                                type: "dashed"
                            },
                            data: []
                        }
                    ],
                    color: ["#4c8ef4"]
                };
                lineOptions.xAxis[0].data = field.valuations_month;
                lineOptions.series[0].data = field.valuations;
                if (field.valuations_month.length > 0) {
                    lineOptions.series[1].data = [];
                    for (let i = 0; i < field.valuations_month.length; i++) {
                        lineOptions.series[1].data.push(
                            field.investment_overview.purchase_price
                        );
                    }
                }
                lineChart.setOption(lineOptions);
            } else {
                lineOptions = {};
                lineOptions = {
                    title: {
                        text: this.$t("property.PROPERTYVALUATION"),
                        top: 10,
                        left: 26,
                        textStyle: {
                            color: "#333",
                            fontFamily: "GothamMedium",
                            fontSize: 12
                        }
                    },
                    legend: {
                        show: true,
                        selectedMode: false,
                        top: 30,
                        left: 26,
                        padding: [0, 0, 27, 0],
                        align: "left",
                        data: ["Property Valuation", "Purchase Price"]
                    },
                    tooltip: {
                        trigger: "axis",
                        opacity: "0.9",
                        backgroundColor: "#485465",
                        textStyle: {
                            fontFamily: "GothamBook",
                            fontSize: "8.4",
                            color: "#fff"
                        }
                    },
                    grid: {
                        show: false,
                        left: "26",
                        right: "10",
                        bottom: "45",
                        containLabel: false
                    },
                    xAxis: [
                        {
                            axisLabel: {
                                fontFamily: "GothamBook",
                                fontSize: "10",
                                color: "#666"
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#f5f7f8"
                                }
                            },
                            type: "category",
                            boundaryGap: false,
                            data: []
                        }
                    ],
                    yAxis: [
                        {
                            show: false,
                            axisLabel: {
                                fontFamily: "GothamBook",
                                fontSize: "10",
                                color: "#666"
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#f5f7f8"
                                }
                            },
                            splitLine: {
                                lineStyle: {
                                    color: ["#f5f7f8"]
                                }
                            }
                        }
                    ],
                    series: [
                        {
                            //   "name": "Property Valuation",
                            type: "line",
                            itemStyle: {
                                normal: {
                                    color: {
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        type: "linear",
                                        global: false,
                                        colorStops: [
                                            {
                                                offset: 0,
                                                color:
                                                    "rgba(67, 146, 241, 0.35)"
                                            },
                                            {
                                                offset: 1,
                                                color:
                                                    "rgba(67, 146, 241, 0.05)"
                                            }
                                        ]
                                    },
                                    lineStyle: {
                                        width: 3,
                                        type: "solid",
                                        color: "#0180ff"
                                    }
                                }
                            },
                            areaStyle: {
                                normal: {}
                            },
                            data: [65, 70, 85, 90, 95, 99]
                        },
                        {
                            //   "name": "Purchase Price",
                            type: "line",
                            lineStyle: {
                                color: "#203862",
                                type: "dashed"
                            },
                            data: []
                        }
                    ],
                    color: ["#4c8ef4"]
                };
                lineOptions.xAxis[0].data = field.valuations_month;
                lineChart.setOption(lineOptions);
            }

            expensePie = echarts.init(document.getElementById("expense-pie"));
            let TotalExpense = this.$t("property.TotalExpense");
            let expenseOptions = {
                tooltip: {
                    trigger: "item",
                    position: "inside",
                    formatter: function(params) {
                        return `${params.name} </br>
                        ${field.currency_symbol} ${NumFormat(params.value)}`;
                    },
                    textStyle: {
                        fontFamily: "GothamMedium",
                        fontSize: 7.5,
                        color: "#fff"
                    }
                },
                series: [
                    {
                        type: "pie",
                        radius: ["70%", "85%"],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: true,
                                position: "center",
                                formatter: function(params) {
                                    return `{title|${TotalExpense}} \n {val|${
                                        field.currency_symbol
                                    }${NumFormat(field.expenses.total)}}`;
                                },
                                rich: {
                                    title: {
                                        fontFamily: "GothamBook",
                                        fontSize: 10,
                                        color: "#2e384d"
                                    },
                                    val: {
                                        fontFamily: "GothamMedium",
                                        fontSize: 13,
                                        color: "#447ef6"
                                    }
                                }
                            },
                            emphasis: {
                                show: false,
                                fontSize: 7.5,
                                fontFamily: "GothamMedium",
                                align: "center",
                                color: "#fff"
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: []
                    }
                ],
                color: ["#9fabbf", "#447ef6", "#8eb0f7", "#a348a4"]
            };

            for (const ele in field.expenses) {
                if (field.expenses.hasOwnProperty(ele)) {
                    const element = field.expenses[ele];
                    if (!element) {
                        field.expenses[ele] = 0;
                    }
                }
            }
            expenseOptions.series[0].data.push(
                {
                    value: field.expenses.maintenance_fee || 0,
                    name: this.$t("property.PropertyManagement")
                },
                {
                    value: field.expenses.management_fee || 0,
                    name: this.$t("property.RentalManagement")
                },
                {
                    value: field.expenses.tax || 0,
                    name: this.$t("property.Tax")
                },
                {
                    value: field.expenses.insurance || 0,
                    name: this.$t("property.Insurance")
                }
            );

            expensePie.setOption(expenseOptions);

            if (field.rental.comparison_display) {
                comparisonChart = echarts.init(
                    document.getElementById("comparison-chart")
                );

                let comparisonOptions = {
                    title: {
                        text: this.$t("property.RevenueComparison"),
                        textStyle: {
                            color: "#333",
                            fontFamily: "GothamMedium",
                            fontSize: 12
                        }
                    },
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "line"
                        },
                        formatter: function(params) {
                            return `${params[0].name} </br>
                        ${field.currency_symbol} ${NumFormat(params[0].value)}`;
                        },
                        textStyle: {
                            fontFamily: "GothamMedium",
                            fontSize: 7.5,
                            color: "#fff"
                        }
                    },
                    legend: {
                        data: [
                            this.$t("property.CurrentRent"),
                            this.$t("property.AirbnbRental1"),
                            this.$t("property.StandardMonthlyRental")
                        ]
                    },
                    grid: {
                        left: 4,
                        top: 50,
                        right: 10,
                        bottom: 0,
                        containLabel: true
                    },
                    xAxis: {
                        type: "value",
                        // max: field.valuations_max_bound,
                        axisLabel: {
                            fontFamily: "GothamBook",
                            fontSize: "10",
                            color: "#666"
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: "#f5f7f8"
                            }
                        }
                    },
                    yAxis: {
                        type: "category",
                        axisLabel: {
                            show: false,
                            fontFamily: "GothamBook",
                            fontSize: "10",
                            color: "#666"
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#f5f7f8"
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: ["#f5f7f8"]
                            }
                        },
                        data: [
                            this.$t("property.StandardMonthlyRental"),
                            this.$t("property.AirbnbRental1"),
                            this.$t("property.CurrentRent")
                        ]
                    },
                    series: [
                        {
                            type: "bar",
                            z: 3,
                            // name: this.$t("property.CurrentRent"),
                            data: [
                                {
                                    name: this.$t(
                                        "property.StandardMonthlyRental"
                                    ),
                                    value: 0,
                                    itemStyle: {
                                        color: "#062991"
                                    }
                                },
                                {
                                    name: this.$t("property.AirbnbRental1"),
                                    value: 0,
                                    itemStyle: {
                                        color: "#7076c8"
                                    }
                                },
                                {
                                    name: this.$t("property.CurrentRent"),
                                    value: 0,
                                    itemStyle: {
                                        color: "#447ef6"
                                    }
                                }
                            ]
                        }
                    ]
                };
                comparisonOptions.series[0].data[2].value =
                    field.net_cash_flow.current_rental_income; // current rent
                comparisonOptions.series[0].data[1].value =
                    field.rental.airbnb_monthly; // airbnb
                comparisonOptions.series[0].data[0].value =
                    field.rental.std_monthly; // standard

                comparisonChart.setOption(comparisonOptions);
            }
        },

        editProp(editTar) {
            let currentRoute = this.property_private.id
                ? this.property_private
                : this.propertySelector;
            this.$emit("editProperty", {
                editTar: editTar,
                currentRoute: currentRoute
            });
        },

        GetPropertyType(val) {
            switch (val) {
                case 1:
                    return this.$t("property.House");
                    break;
                case 2:
                    return this.$t("property.Townhome");
                    break;
                case 3:
                    return this.$t("property.Apartment");
                    break;
                case 4:
                    return this.$t("property.Commercial");
                    break;
                default:
                    return this.$t("property.NotSetPropType");
                    break;
            }
        },

        goToManage() {
            this.$emit("goToManage", this.property_private);
            this.$emit("closeAside", "prop");
        },

        UnitFormat(val) {
            if (!val) return;
            if (val.toLowerCase() == "mt") {
                return this.$t("addProperty.SQM");
            } else {
                return this.$t("addProperty.SQFT");
            }
        }
    },

    filters: {
        NumFormat: function(val) {
            if (!val) return "-";
            val = Number.parseFloat(val).toFixed(1);
            val = Math.abs(val);
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        NumFormatAndShowSymbol: function(val) {
            if (!val) return "";
            val = Number.parseInt(val);
            let symbol;
            if (val < 0) {
                symbol = "-";
            }
            return symbol;
        },

        NumFormatToZero: function(val) {
            if (!val) {
                return "0";
            } else {
                return val;
            }
        },

        KeepODecimal: function(val) {
            val = Number.parseInt(val);
            return val;
        },

        KeepOneDecimal: function(val) {
            if (!val) return "-";
            val = Number.parseFloat(val).toFixed(1);
            return val;
        },

        returnDash: function(val) {
            if (!val) {
                return "-";
            } else {
                return val;
            }
        }
    },

    watch: {
        propertySelector: {
            handler(newVal, oldVal) {
                if (newVal.id) {
                    this.property_private = newVal;
                    this.initialData();
                }
            },
            deep: true
        },

        property_private: {
            handler(newVal, oldVal) {
                this.$emit("chanegAside", newVal.name);
            },
            deep: true
        }
    }
};
</script>

<style lang="scss">
.PIDContainer {
    .property-selector {
        margin-bottom: 17px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .el-button {
            width: auto;
            height: 27px;
            line-height: 1;
            border-radius: 2.6px;
            background-color: var(--windows-blue);
            border-color: transparent;
            padding-top: 0;
            padding-bottom: 0;
            font-family: GothamBook;
            font-size: 12px;
            letter-spacing: 0.3px;
            text-align: center;
            color: var(--white);
        }
    }
    .property-content {
        display: flex;
        flex-wrap: wrap-reverse;
    }
    .property-card {
        position: relative;
    }
    .property-profile {
        .property-profile-img {
            height: 200px;
            margin-left: -17px;
            margin-right: -17px;
            margin-top: 10px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: top;
            }
        }
        .property-type {
            margin-top: 20px;
            font-family: GothamMedium;
            font-size: 10px;
            line-height: 10px;
            color: #4a4a4a;
            margin-bottom: 10px;
        }
        .property-name {
            font-family: GothamMedium;
            font-size: 20px;
            color: #4a4a4a;
            margin-bottom: 10px;
        }
        .property-desc {
            font-family: GothamBook;
            font-size: 10px;
            line-height: 1.45;
            color: var(--brownish-grey);
            margin-bottom: 18px;
        }
        .property-layout {
            display: flex;
            flex-wrap: wrap;
            li {
                display: inline-block;
                width: calc(50% - 4px);
                text-align: left;
                margin-bottom: 16px;
                position: relative;
                text-transform: capitalize;
                &:before {
                    content: "";
                    display: inline-block;
                    width: 12px;
                    height: 12px;
                    background-repeat: no-repeat;
                    background-size: contain;
                    margin-right: 5px;
                    margin-bottom: -2px;
                }
                &.layout-internal:before {
                    background-image: url("../../../../website_20/static/img/layout-internal.svg");
                }
                &.layout-floor:before {
                    background-image: url("../../../../website_20/static/img/layout-floor.svg");
                }
                &.layout-areaLot:before {
                    background-image: url("../../../../website_20/static/img/layout-areaLot.svg");
                }
                &.layout-bedrooms:before {
                    background-image: url("../../../../website_20/static/img/layout-bed.svg");
                }
                &.layout-bathrooms:before {
                    background-image: url("../../../../website_20/static/img/layout-bathroom.svg");
                }
                &.layout-kitchens:before {
                    background-image: url("../../../../website_20/static/img/layout-kitchen.svg");
                }
                &.layout-livingRooms:before {
                    background-image: url("../../../../website_20/static/img/layout-living.svg");
                }
                // &.layout-balconies:before {
                //     background-image: url("../../../../website_20/static/img/layout-balcony.svg");
                // }
                &.layout-parkingSpaces:before {
                    background-image: url("../../../../website_20/static/img/layout-parking.svg");
                }
            }
        }
        .border-top {
            border-top: solid 1px #eee;
        }
        .editor-item {
        }
        .flex-item {
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .item-name,
            .item-val {
                font-family: GothamBook;
                font-size: 11px;
                color: var(--brownish-grey);
            }
            .item-val {
                font-family: GothamMedium;
                color: #333333;
            }
        }
    }
    .property-mortgage {
        border-top: solid 1px #eee;
        padding-top: 14px;
        .edit-btn {
            position: absolute;
            top: 17px;
            right: 0;
            padding-right: 15px;
            font-family: GothamBook;
            font-size: 11px;
            letter-spacing: 0.4px;
            color: #333333;
            &:after {
                content: "";
                position: absolute;
                right: 0;
                top: 2px;
                display: inline-block;
                width: 10px;
                height: 10px;
                background: url("../../../../website_20/static/img/icon-edit.svg")
                    no-repeat;
            }
        }
        .mortgage-title {
            display: block;
            width: 100%;
            font-family: GothamMedium;
            font-size: 12px;
            color: #333333;
            margin-bottom: 6px;
        }
        .mortgage-subtitle {
            display: block;
            width: 100%;
            font-family: GothamBook;
            font-size: 10px;
            color: var(--brownish-grey);
        }
        .progress-dashboard {
            text-align: center;
            margin-top: 15px;
            position: relative;
            .mortgage-hint {
                margin: 10px 0;
                font-family: GothamBook;
                font-size: 13px;
                line-height: 1.27;
                text-align: left;
                color: var(--brownish-grey);
            }
            .mortgage-paid {
                position: absolute;
                font-family: GothamBook;
                font-size: 10px;
                line-height: 0.91;
                letter-spacing: -0.1px;
                text-align: center;
                color: #333333;
                left: 50%;
                top: 60%;
                transform: translate(-50%);
            }
        }
        .el-progress-circle {
            svg {
                height: auto;
                width: auto;
            }
        }
        .mortgage-list {
            display: flex;
            flex-wrap: wrap;
            .mortgage-flex {
                display: inline-block;
                width: 50%;
                .flex-item,
                .flex-val {
                    width: 100%;
                }
                .flex-item {
                    margin-bottom: 6px;
                    font-family: GothamBook;
                    font-size: 10px;
                    color: var(--brownish-grey);
                }
                .flex-val {
                    font-family: GothamMedium;
                    font-size: 12.2px;
                    color: #333333;
                    margin-bottom: 16px;
                }
            }
        }
    }
    .property-expenses {
        border-top: solid 1px #eee;
        padding-top: 14px;
        .edit-btn {
            position: absolute;
            top: 17px;
            right: 0;
            padding-right: 15px;
            font-family: GothamBook;
            font-size: 11px;
            letter-spacing: 0.4px;
            color: #333333;
            &:after {
                content: "";
                display: inline-block;
                position: absolute;
                right: 0;
                top: 2px;
                width: 10px;
                height: 10px;
                background: url("../../../../website_20/static/img/icon-edit.svg")
                    no-repeat;
            }
        }
        .expenses-title,
        .expenses-subtitle {
            font-family: GothamMedium;
            font-size: 12px;
            color: #333333;
        }
        .expenses-subtitle {
            display: block;
            font-family: GothamBook;
        }
        #expense-pie {
            width: 132px;
            height: 132px;
            margin: 0 auto;
        }
        .expenses-list {
            display: flex;
            flex-wrap: wrap;
            li {
                width: 50%;
                margin-bottom: 15px;
                font-family: GothamBook;
                font-size: 10px;
                letter-spacing: -0.1px;
                color: var(--brownish-grey);
                &:before {
                    content: "";
                    display: inline-block;
                    margin-right: 5px;
                    width: 7px;
                    height: 7px;
                    border-radius: 50%;
                    background-color: #9fabbf;
                }
                &.management:before {
                    background-color: #447ef6;
                }
                &.tax:before {
                    background-color: #8eb0f7;
                }
                &.insurance:before {
                    background-color: #a348a4;
                }
            }
        }
    }
    .common-style {
        h2 {
            height: auto;
            line-height: normal;
            font-family: GothamMedium;
            font-size: 12px;
            color: #333333;
            margin: 16px 0;
            span {
                font-family: GothamBook;
            }
        }
    }
    .flex-reserve {
        display: flex;
        width: 100%;
        flex-wrap: wrap-reverse;
    }
    .line-overlay {
        position: relative;
        height: 300px;
        margin-left: -17px;
        margin-right: -17px;
        width: 100%;
        border-bottom: 1px solid #eee;
        #line-chart {
            width: 100%;
            height: 100%;
        }
        .no-valuation {
            position: absolute;
            left: 50%;
            transform: translate(-47%);
            width: 100%;
            height: 100%;
            display: flex;
            top: 0;
            justify-content: center;
            align-items: center;
            font-family: GothamBook;
            font-size: 12px;
            line-height: 1.5;
            text-align: center;
            color: #203862;
        }
    }
    .box-bottom {
        padding-bottom: 16px;
        border-bottom: 1px solid #eee;
    }
    .current-value {
        width: 100%;
        .price-list {
            .current-val {
                font-family: GothamMedium;
                height: 24px;
                font-size: 20px;
                letter-spacing: -0.4px;
                color: var(--windows-blue);
                margin-bottom: 4px;
            }
            .subval {
                font-family: GothamBook;
                font-size: 13px;
                line-height: 0.77;
                color: #9b9b9b;
                margin-bottom: 19px;
            }
            .purchase-price {
                font-family: GothamBook;
                font-size: 11px;
                color: #333333;
                margin-bottom: 12px;
                height: 13px;
            }
            .purchase-price-num {
                font-family: GothamMedium;
                font-size: 13px;
                color: #333333;
                margin-bottom: 4px;
            }
        }
        .current-gain {
            display: flex;
            border: solid 0.6px rgba(46, 91, 255, 0.08);
            padding: 20px 0;
            border-radius: 2px;
            box-shadow: 0 2px 10px 0 rgba(155, 155, 155, 0.5);
            background-color: var(--white);
            & > div {
                display: inline-block;
                width: 50%;
                padding-left: 20px;
                .gain-title {
                    font-family: GothamBook;
                    font-size: 11px;
                    color: #666660;
                    margin-bottom: 8px;
                }
                .gain-percent {
                    font-family: GothamBook;
                    font-size: 13px;
                    color: var(--windows-blue);
                    margin-bottom: 8px;
                    &.up {
                        position: relative;
                        margin-left: 14px;
                        color: #447ef6;
                        &:before {
                            content: "";
                            width: 0px;
                            height: 0px;
                            position: absolute;
                            left: -13px;
                            top: 8px;
                            display: inline-block;
                            border: 3px solid transparent;
                            border-top: 3px solid #447ef6;
                            border-left: 3px solid #447ef6;
                            transform: rotate(45deg);
                        }
                    }
                    &.down {
                        position: relative;
                        margin-left: 14px;
                        color: #c3484d;
                        &:before {
                            content: "";
                            width: 0px;
                            height: 0px;
                            position: absolute;
                            left: -13px;
                            top: 4px;
                            display: inline-block;
                            border: 3px solid transparent;
                            border-bottom: 3px solid #c3484d;
                            border-left: 3px solid #c3484d;
                            -webkit-transform: rotate(45deg);
                            transform: rotate(-45deg);
                        }
                    }
                }
                .gain-num {
                    font-family: GothamBook;
                    font-size: 13px;
                    color: #333333;
                    word-break: break-all;
                }
                &.border-right {
                    border-right: 1px solid #e9eff4;
                }
            }
        }
    }
    .cash-flow {
        .cash-box {
            display: flex;
            justify-content: space-between;
            .cash-item {
                width: calc(50% - 5px);
                p {
                    font-family: GothamBook;
                    font-size: 11px;
                    color: var(--brownish-grey);
                    margin-bottom: 6px;
                }
                .net-num {
                    font-family: GothamMedium;
                    font-size: 14px;
                    line-height: 1;
                    margin-bottom: 19px;
                    color: var(--windows-blue);
                    &.red {
                        color: #bc3036;
                    }
                }
                .cash-card {
                    border-radius: 0.6px;
                    border: solid 0.6px rgba(46, 91, 255, 0.08);
                    box-shadow: 0 6px 11px 0 rgba(46, 91, 255, 0.07);
                    background-color: var(--white);
                    padding: 9px 8px;
                    img {
                        display: inline-block;
                        width: 27px;
                        height: 27px;
                        object-fit: contain;
                        margin-bottom: 7px;
                    }
                    .cash-title {
                        font-family: GothamBook;
                        font-size: 9px;
                        color: var(--brownish-grey);
                        margin-bottom: 7px;
                    }
                    .cash-num {
                        font-family: GothamMedium;
                        font-size: 14px;
                        line-height: 1;
                        color: #333333;
                    }
                }
            }
        }
    }
    .property-outlook {
        .outlook-slider {
            display: flex;
            margin-bottom: 43px;
            li {
                width: 25%;
                height: 24px;
                position: relative;
                &.strong-sell {
                    background-color: #802126;
                    color: #802126;
                }
                &.sell {
                    background-color: #bc3036;
                    color: #bc3036;
                }
                &.hold {
                    background-color: var(--windows-blue);
                    color: var(--windows-blue);
                }
                &.strong-hold {
                    background-color: #203862;
                    color: #203862;
                }
                .outlook-advice {
                    position: absolute;
                    color: inherit;
                    font-family: GothamMedium;
                    font-size: 11px;
                    font-weight: 500;
                    letter-spacing: 0.5px;
                    bottom: -100%;
                    transform: translateY(50%);
                    display: inline-block;
                    width: 100%;
                    text-align: center;
                }
                &.pin:before {
                    content: "";
                    position: absolute;
                    width: 9px;
                    height: 17px;
                    left: 50%;
                    transform: translate(-50%);
                    bottom: -50%;
                    background: url("../../../../website_20/static/img/pid-outlook-pin.svg")
                        no-repeat;
                    background-size: cover;
                }
            }
        }
        .outlook-msg-box {
            &.red {
                p {
                    background-color: #f8eaea;
                    color: #bc3036;
                }
            }
            p {
                font-family: GothamBook;
                font-size: 12px;
                line-height: 1.08;
                color: #3a66d2;
                padding: 12px;
                border-radius: 1.1px;
                background-color: rgba(59, 107, 191, 0.1);
            }
        }
    }
    .rent-analysis {
        margin-left: -17px;
        margin-right: -17px;
        margin-top: 16px;
        padding: 16px 0;
        background-color: #deecff;
        h2 {
            padding: 0 17px;
            margin: 0 0 16px;
        }
        .rent-card {
            border-radius: 4px;
            box-shadow: 0 5px 32px 0 rgba(0, 62, 100, 0.04);
            background-color: var(--white);
            padding: 17px 16px;
            margin: 0 17px 17px;

            h3 {
                font-family: GothamMedium;
                font-size: 11px;
                color: #333333;
                margin-bottom: 17px;
                .edit-icon {
                    &:after {
                        content: "";
                        display: inline-block;
                        margin: 0 5px;
                        width: 10px;
                        height: 10px;
                        background: url("../../../../website_20/static/img/icon-edit.svg")
                            no-repeat;
                        background-size: contain;
                    }
                }
            }
            .rent-flex {
                display: flex;
                .rent-item {
                    width: 50%;
                    .no-rent {
                        font-family: GothamBook;
                        font-size: 13px;
                        color: var(--brownish-grey);
                    }
                    .rent-revenue {
                        font-family: GothamBook;
                        font-size: 11px;
                        line-height: 1;
                        color: var(--brownish-grey);
                        margin-bottom: 5px;
                    }
                    .rent-num {
                        font-family: GothamMedium;
                        font-size: 13px;
                        font-weight: 500;
                        line-height: 1;
                        color: #447ef6;
                    }
                    .rent-calculate {
                        font-family: GothamMedium;
                        font-size: 11px;
                        font-weight: 500;
                        line-height: 1.77;
                        color: #447ef6;
                    }
                    .rent-percent {
                        font-family: GothamMedium;
                        font-size: 13px;
                        color: #333333;
                    }
                }
            }
            .rent-occupancy {
                margin-top: 12px;
                .occupancy-flex {
                    display: flex;
                    justify-content: space-between;
                    .occupancy-title {
                        font-family: GothamBook;
                        font-size: 10px;
                        color: #022d60;
                    }
                    .occupancy-val {
                        font-family: GothamMedium;
                        font-size: 10px;
                        font-weight: 500;
                        text-align: right;
                        color: #022d60;
                    }
                }
                .occupancy-percent {
                }
            }
        }
        .rent-card:nth-child(1) {
            border-bottom: 4px solid #447ef6;
        }
        .rent-card:nth-child(2) {
            border-bottom: 4px solid #7076c8;
        }
        .rent-card:nth-child(3) {
            border-bottom: 4px solid #062991;
        }
        .revenue-comparison {
            margin: 0 17px 17px;
            padding: 20px 18px;
            border-radius: 4px;
            box-shadow: 0 5px 32px 0 rgba(0, 62, 100, 0.04);
            background-color: var(--white);
            position: relative;
            .comparison-dot-list {
                position: absolute;
                display: flex;
                left: 23px;
                top: 44px;
                li {
                    font-family: GothamBook;
                    font-size: 10px;
                    line-height: 0.92;
                    color: #2e384d;
                    margin-right: 10px;
                    &:before {
                        content: "";
                        display: inline-block;
                        margin-right: 5px;
                        width: 7px;
                        height: 7px;
                        border-radius: 50%;
                        background-color: #447ef6;
                    }
                    &:nth-child(2):before {
                        background-color: #7076c8;
                    }
                    &:nth-child(3):before {
                        background-color: #062991;
                    }
                }
            }
            .comparison-result {
                margin-top: 10px;
                border-radius: 1.1px;
                background-color: #ebf0f8;
                p {
                    font-family: GothamBook;
                    padding: 12px;
                    font-size: 13px;
                    line-height: 1.2;
                    color: #3a66d2;
                }
            }

            #comparison-chart,
            .comparison-result {
                width: 100%;
                height: 100%;
            }
            .comparison-result {
                border-radius: 1.1px;
            }
            #comparison-chart {
                height: 176px;
            }
        }
        .book-consultation {
            display: inline-block;
            width: 100%;
            padding: 0 16px;
            a {
                box-shadow: none;
                font-family: GothamBook;
                font-size: 10px;
                letter-spacing: 0.2px;
                text-align: center;
                color: var(--white);
                height: 28px;
                line-height: normal;
                width: 100%;
                display: inline-block;
            }
        }
    }
}

@media (min-width: 768px) {
    .PIDContainer {
        .property-content {
            .property-content-l {
            }
            .property-content-r {
                .common-style {
                    border-radius: 6px;
                    box-shadow: 0 6px 36px 0 rgba(0, 62, 100, 0.04);
                    border: solid 1px #e5edf3;
                    background-color: var(--white);
                    padding: 0 16px 20px;
                    margin-bottom: 20px;
                    .box-bottom {
                        border-bottom: 0;
                        padding-bottom: 0;
                    }
                }
            }
        }
        .property-card {
            border-radius: 6px;
            box-shadow: 0 5px 30px 0 rgba(0, 62, 100, 0.04);
            border: solid 0.8px #e5edf3;
            background-color: var(--white);
            margin-bottom: 20px;
            overflow: hidden;
        }
        .flex-reserve {
            flex-wrap: nowrap;
        }
        .property-mortgage {
            .progress-dashboard {
                .mortgage-hint {
                    margin-top: 30px;
                    margin-bottom: 0;
                }
            }
        }
        .rent-analysis {
            position: relative;
            .book-consultation {
                position: absolute;
                right: 25px;
                top: 16px;
                padding: 0;
                width: auto;
            }
        }
    }
}

@media (min-width: 992px) {
    .PIDContainer {
        .property-selector {
            .el-select {
                width: 386px;
            }
        }
        .property-content {
            flex-wrap: nowrap;
            justify-content: space-between;
            .property-content-l {
                width: 265px;
            }
            .property-content-r {
                width: calc(100% - 285px);
                .common-flex {
                    display: flex;
                    border-radius: 6px;
                    box-shadow: 0 6px 36px 0 rgba(0, 62, 100, 0.04);
                    border: solid 1px #e5edf3;
                    background-color: var(--white);
                    padding: 0 16px;
                    margin-bottom: 20px;
                    justify-content: space-between;
                    .common-style {
                        border-radius: unset;
                        box-shadow: unset;
                        border: unset;
                        background-color: unset;
                        padding: unset;
                        margin-bottom: unset;
                    }
                    .cash-flow,
                    .property-outlook {
                        width: calc(50% - 10px);
                        border-radius: 6px;
                        box-shadow: 0 5px 32px 0 rgba(0, 62, 100, 0.04);
                        border: solid 0.9px #e5edf3;
                        background-color: var(--white);
                        padding: 16px;
                    }
                    .line-overlay {
                        width: calc(100% - 200px);
                        margin-left: 0;
                        margin-right: 0;
                        height: 310px;
                        border-bottom: 0;
                    }
                }
                .common-group {
                    background-color: unset;
                    border-radius: unset;
                    box-shadow: unset;
                    border: unset;
                    padding: 0;
                }
                .rent-analysis {
                    border-radius: 6px;
                    box-shadow: 0 6px 36px 0 rgba(0, 62, 100, 0.04);
                    border: solid 1px #e5edf3;
                    background-color: #deecff;
                    margin: 0;
                    padding: 23px 13px;
                    .rent-list {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 20px;
                        .rent-card {
                            width: calc(33% - 7.5px);
                        }
                    }
                    h2,
                    .rent-card {
                        margin: 0;
                    }
                    h2 {
                        padding: 0;
                        margin-bottom: 25px;
                    }
                    .rent-card {
                        padding: 15px;
                        .rent-flex {
                            display: block;
                            .rent-item {
                                width: 100%;
                                margin-bottom: 15px;
                            }
                        }
                        .rent-occupancy {
                            .occupancy-flex {
                                .occupancy-label {
                                    font-family: GothamBook;
                                    font-size: 10px;
                                    color: #022d60;
                                }
                                .occupancy-val {
                                    font-family: GothamMedium;
                                    font-size: 10px;
                                    color: #022d60;
                                }
                            }
                        }
                    }
                }
            }
        }
        .property-card {
            padding: 10px 16px;
            .edit-btn {
                top: 12px;
                right: 16px;
            }
            .edit-link {
                font-family: GothamBook;
                display: block;
                width: 100%;
                font-size: 11px;
                line-height: 1.2;
                letter-spacing: 0.39px;
                text-align: right;
                color: #333333;
                padding-top: 10px;
                position: relative;
                padding-right: 15px;
                &:after {
                    content: "";
                    display: inline-block;
                    position: absolute;
                    right: 0;
                    top: 11px;
                    width: 10px;
                    height: 10px;
                    background: url("../../../../website_20/static/img/icon-edit.svg")
                        no-repeat;
                    background-size: contain;
                }
            }
        }
        .property-profile {
            padding-top: 0;
            .property-profile-img {
                margin-left: -16px;
                margin-right: -16px;
                margin-top: 0;
            }
        }
        .current-value {
            width: 200px;
            border-right: solid 1px #e5edf3 !important;
            padding-bottom: 20px !important;
            padding-right: 16px !important;
            .current-gain {
                & > div {
                    padding-left: 12px;
                }
            }
        }
        .rent-analysis {
            .revenue-comparison {
                margin: 0;
                .comparison-flex {
                    display: flex;
                    justify-content: space-between;
                    #comparison-chart,
                    .comparison-result {
                        width: calc(50% - 7.5px);
                    }
                    .comparison-result {
                        margin-top: 50px;
                    }
                }
            }
            .book-consultation {
                padding: 0;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/account/PIDContainer.vue